export const STORE_ACTION_PERSIST = "STORE_PERSIST";
export const STORE_ACTION_CLEAR = "STORE_CLEAR";
